module.exports = __webpack_public_path__ + "../assets/img/f60e569f8c17be9abfd505caac5f67c4.svg";